import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import classNames from "classnames";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

//import action
import { getChartsData as onGetChartsData } from "../../store/actions";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import LatestTranaction from "./LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

const Dashboard = props => {

  const DashboardProperties = createSelector(
    (state) => state.Dashboard,
    (dashboard) => ({
      chartsData: dashboard.chartsData
    })
  );

  const { chartsData } = useSelector(DashboardProperties);

  // --- API'DEN GELECEK İSTATİSTİKLER İÇİN STATE ---
  const [stats, setStats] = useState({
    activeAdverts: 0,
    completedTasks: 0,
    pendingOffers: 0,
    isLoading: true
  });

  // OData API'den İstatistikleri Çekme (Kullanıcıya Özel ve /odata olmadan)
  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        // LocalStorage'dan giriş yapan kullanıcıyı alıyoruz
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;

        // Eğer kullanıcı ID'si yoksa fetch atma (Örn: giriş yapılmamışsa)
        if (!userId) {
          console.warn("Kullanıcı ID bulunamadı.");
          setStats(prev => ({ ...prev, isLoading: false }));
          return;
        }

        // 1. Aktif İlanlar (Is_Active = true VE Users_ID = userId)
        const resActive = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert?$filter=Is_Active eq true and Users_ID eq ${userId}`);
        const dataActive = await resActive.json();
        const activeCount = dataActive.value ? dataActive.value.length : 0;

        // 2. Tamamlanan Taşımalar (Durumu Tamamlandı VE Users_ID = userId)
        const resCompleted = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_DeliveryStatus?$filter=Advert_DeliveryStatus_Status eq 'Tamamlandı' and Users_ID eq ${userId}`);
        const dataCompleted = await resCompleted.json();
        const completedCount = dataCompleted.value ? dataCompleted.value.length : 0;

        // 3. Bekleyen Teklifler (Durumu Bekliyor VE Users_ID = userId)
        const resPending = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers?$filter=Offer_Status eq 'Bekliyor' and Users_ID eq ${userId}`);
        const dataPending = await resPending.json();
        const pendingCount = dataPending.value ? dataPending.value.length : 0;

        // Stateleri güncelle
        setStats({
          activeAdverts: activeCount,
          completedTasks: completedCount,
          pendingOffers: pendingCount,
          isLoading: false
        });

      } catch (error) {
        console.error("Dashboard istatistikleri çekilirken hata oluştu:", error);
        setStats(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchDashboardStats();
  }, []);

  // Kartlara basılacak dinamik veri dizisi
  const reports = [
    { 
      title: "Aktif İlanlar", 
      iconClass: "bx-car", 
      description: stats.isLoading ? "..." : stats.activeAdverts 
    },
    { 
      title: "Tamamlanan Taşımalar", 
      iconClass: "bx-check-circle", 
      description: stats.isLoading ? "..." : stats.completedTasks 
    },
    {
      title: "Bekleyen Teklifler",
      iconClass: "bx-time-five",
      description: stats.isLoading ? "..." : stats.pendingOffers,
    },
  ];

  const [periodData, setPeriodData] = useState([]);
  const [periodType, setPeriodType] = useState("yearly");

  useEffect(() => {
    setPeriodData(chartsData);
  }, [chartsData]);

  const onChangeChartPeriod = pType => {
    setPeriodType(pType);
    dispatch(onGetChartsData(pType));
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(onGetChartsData("yearly"));
  }, [dispatch]);

  //meta title
  document.title = "Anasayfa | Lojgo";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Anasayfa")} breadcrumbItem={props.t("Özet Ekranı")} />

          <Row>
            {/* Sol Taraf */}
            <Col xl="4">
              <WelcomeComp />
              <MonthlyEarning />
            </Col>
            
            {/* Sağ Taraf: API'den Çekilen İstatistikler */}
            <Col xl="8">
              <Row>
                {(reports || [])?.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium mb-2">
                              {report.title}
                            </p>
                            <h4 className="mb-0">
                                {stats.isLoading ? <Spinner size="sm" color="primary" /> : report.description}
                            </h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i className={"bx " + report.iconClass + " font-size-24"}></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>

              <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">Taşıma İstatistikleri</h4>
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          <Link to="#" className={classNames({ active: periodType === "weekly" }, "nav-link")}
                            onClick={() => { onChangeChartPeriod("weekly"); }} id="one_week">
                            Hafta
                          </Link>{" "}
                        </li>
                        <li className="nav-item">
                          <Link to="#" className={classNames({ active: periodType === "monthly" }, "nav-link")}
                            onClick={() => { onChangeChartPeriod("monthly"); }} id="one_month">
                            Ay
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="#" className={classNames({ active: periodType === "yearly" }, "nav-link")}
                            onClick={() => { onChangeChartPeriod("yearly"); }} id="one_year">
                            Yıl
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <StackedColumnChart periodData={periodData} dataColors='["--bs-primary", "--bs-warning", "--bs-success"]' />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            {/**    <Col xl="4">
              <SocialSource />
            </Col>*/}
         
            <Col xl="4">
              <ActivityComp />
            </Col>
            <Col xl="4">
              <TopCities />
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <LatestTranaction />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);